import * as fromContactPersonAction from 'app/vanilla/modules/order-builder/modules/location-specification/actions/contact-person.action';

export interface State {
  name: string | null;
  contactPersonRoleId: number | null;
  countryAreaCode: string | null;
  phone: string | null;
  extension: string | null;
  email: string | null;
}

const initialState: State = {
  name: null,
  contactPersonRoleId: null,
  countryAreaCode: null,
  phone: null,
  extension: null,
  email: null,
};

export function reducer(state = initialState, action: fromContactPersonAction.Actions): State {
  switch (action.type) {
    case fromContactPersonAction.ActionTypes.INIT:
    case fromContactPersonAction.ActionTypes.ADD_CONTACT: {
      return state;
    }
    case fromContactPersonAction.ActionTypes.SET_NAME: {
      return { ...state, name: action.payload };
    }
    case fromContactPersonAction.ActionTypes.SET_ROLE: {
      return { ...state, contactPersonRoleId: action.payload };
    }
    case fromContactPersonAction.ActionTypes.SET_COUNTRY_AREA_CODE: {
      return { ...state, countryAreaCode: action.payload };
    }
    case fromContactPersonAction.ActionTypes.SET_PHONE: {
      return { ...state, phone: action.payload };
    }
    case fromContactPersonAction.ActionTypes.SET_EXTENSION: {
      return { ...state, extension: action.payload };
    }
    case fromContactPersonAction.ActionTypes.SET_EMAIL: {
      return { ...state, email: action.payload };
    }
    case fromContactPersonAction.ActionTypes.CLEAR: {
      return {
        ...state,
        name: null,
        contactPersonRoleId: null,
        countryAreaCode: null,
        phone: null,
        extension: null,
        email: null,
      };
    }
    default: {
      return state;
    }
  }
}
